import { get } from './requests'

export const getOptionsTypesDelay = key => get(['types-delay'], { key })

export const getOptionsReasonDelay = key => get(['reasons-delay'], { key })
